// extracted by mini-css-extract-plugin
export var card = "_ls-5";
export var cardSelected = "_ls-4";
export var image = "_ls-3";
export var modal = "_ls-0";
export var modalContent = "_ls-1";
export var table = "_ls-2";